{
  "labels": {
    "signUp": "",
    "signIn": "",
    "paste": "Liitä",
    "pasteAsPlaintext": "Liitä pelkkänä tekstinä",
    "pasteCharts": "Liitä kaaviot",
    "chartType_bar": "",
    "chartType_line": "",
    "chartType_radar": "",
    "chartType_plaintext": "",
    "selectAll": "Valitse kaikki",
    "multiSelect": "Lisää kohde valintaan",
    "moveCanvas": "Siirrä piirtoaluetta",
    "cut": "Leikkaa",
    "copy": "Kopioi",
    "copyAsPng": "Kopioi leikepöydälle PNG-tiedostona",
    "copyAsSvg": "Kopioi leikepöydälle SVG-tiedostona",
    "copyText": "Kopioi tekstinä",
    "copySource": "Kopioi lähde leikepöydälle",
    "convertToCode": "Muunna koodiksi",
    "bringForward": "Tuo eteenpäin",
    "sendToBack": "Vie taakse",
    "bringToFront": "Tuo eteen",
    "sendBackward": "Vie taaksepäin",
    "delete": "Poista",
    "copyStyles": "Kopioi tyyli",
    "pasteStyles": "Liitä tyyli",
    "stroke": "Piirto",
    "changeStroke": "",
    "background": "Tausta",
    "changeBackground": "",
    "fill": "Täyttö",
    "strokeWidth": "Viivan leveys",
    "strokeStyle": "Viivan tyyli",
    "strokeStyle_solid": "Yhtenäinen",
    "strokeStyle_dashed": "Katkoviiva",
    "strokeStyle_dotted": "Pisteviiva",
    "sloppiness": "Viivan tarkkuus",
    "pressure": "",
    "pressure_constant": "",
    "pressure_variable": "",
    "opacity": "Peittävyys",
    "textAlign": "Tekstin tasaus",
    "edges": "Reunat",
    "sharp": "Terävä",
    "round": "Pyöristetty",
    "arrowheads": "Nuolenkärjet",
    "arrowhead_none": "Ei mitään",
    "arrowhead_arrow": "Nuoli",
    "arrowhead_bar": "Tasapää",
    "arrowhead_circle": "Ympyrä",
    "arrowhead_circle_outline": "Ympyrä (ääriviiva)",
    "arrowhead_triangle": "Kolmio",
    "arrowhead_triangle_outline": "Kolmio (ääriviiva)",
    "arrowhead_diamond": "",
    "arrowhead_diamond_outline": "",
    "arrowhead_crowfoot_many": "",
    "arrowhead_crowfoot_one": "",
    "arrowhead_crowfoot_one_or_many": "",
    "arrowhead_cardinality_one": "",
    "arrowhead_cardinality_many": "",
    "arrowhead_cardinality_one_or_many": "",
    "arrowhead_cardinality_exactly_one": "",
    "arrowhead_cardinality_zero_or_one": "",
    "arrowhead_cardinality_zero_or_many": "",
    "more_options": "",
    "cardinality": "",
    "arrowtypes": "",
    "arrowtype_sharp": "",
    "arrowtype_round": "",
    "arrowtype_elbowed": "",
    "fontSize": "Kirjasinkoko",
    "fontFamily": "Kirjasintyyppi",
    "addWatermark": "Lisää \"Tehty Excalidrawilla\"",
    "handDrawn": "Käsinpiirretty",
    "normal": "Tavallinen",
    "code": "Koodi",
    "small": "Pieni",
    "medium": "Keskikoko",
    "large": "Suuri",
    "veryLarge": "Erittäin suuri",
    "solid": "Yhtenäinen",
    "hachure": "Vinoviivoitus",
    "zigzag": "",
    "crossHatch": "Ristiviivoitus",
    "thin": "Ohut",
    "bold": "Lihavoitu",
    "left": "Vasen",
    "center": "Keskitä",
    "right": "Oikea",
    "extraBold": "Erittäin lihavoitu",
    "architect": "Arkkitehti",
    "artist": "Taiteilija",
    "cartoonist": "Sarjakuva",
    "fileTitle": "Tiedostonimi",
    "colorPicker": "Värin valinta",
    "canvasColors": "Käytössä piirtoalueella",
    "canvasBackground": "Piirtoalueen tausta",
    "drawingCanvas": "Piirtoalue",
    "clearCanvas": "Tyhjennä piirtoalue",
    "layers": "Tasot",
    "actions": "Toiminnot",
    "language": "Kieli",
    "liveCollaboration": "Live Yhteistyö...",
    "duplicateSelection": "Monista",
    "untitled": "Nimetön",
    "name": "Nimi",
    "yourName": "Nimesi",
    "madeWithExcalidraw": "Tehty Excalidrawilla",
    "group": "Ryhmitä valinta",
    "ungroup": "Pura valittu ryhmä",
    "collaborators": "Yhteistyökumppanit",
    "you": "",
    "toggleGrid": "Näytä tai piilota ruudukko",
    "loadingScene": "Ladataan työtä…",
    "loadScene": "",
    "align": "Tasaa",
    "alignTop": "Tasaa ylös",
    "alignBottom": "Tasaa alas",
    "alignLeft": "Tasaa vasemmalle",
    "alignRight": "Tasaa oikealle",
    "centerVertically": "Keskitä pystysuunnassa",
    "centerHorizontally": "Keskitä vaakasuunnassa",
    "distributeHorizontally": "Jaa vaakasuunnassa",
    "distributeVertically": "Jaa pystysuunnassa",
    "flipHorizontal": "Käännä vaakasuunnassa",
    "flipVertical": "Käännä pystysuunnassa",
    "viewMode": "Katselutila",
    "share": "Jaa",
    "showStroke": "Näytä viivan värin valitsin",
    "showBackground": "Näytä taustavärin valitsin",
    "showFonts": "",
    "toggleTheme": "",
    "theme": "Teema",
    "decreaseFontSize": "Pienennä kirjasinkokoa",
    "increaseFontSize": "Kasvata kirjasinkokoa",
    "unbindText": "Irroita teksti",
    "bindText": "Kiinnitä teksti säiliöön",
    "createContainerFromText": "",
    "link": {
      "edit": "Muokkaa linkkiä",
      "editEmbed": "",
      "create": "",
      "label": "Linkki",
      "labelEmbed": "",
      "empty": "Linkkiä ei ole asetettu",
      "hint": "",
      "goToElement": ""
    },
    "lineEditor": {
      "edit": "Muokkaa riviä",
      "editArrow": ""
    },
    "polygon": {
      "breakPolygon": "",
      "convertToPolygon": ""
    },
    "elementLock": {
      "lock": "Lukitse",
      "unlock": "Poista lukitus",
      "lockAll": "Lukitse kaikki",
      "unlockAll": "Poista lukitus kaikista"
    },
    "sidebarLock": "Pidä sivupalkki avoinna",
    "selectAllElementsInFrame": "",
    "removeAllElementsFromFrame": "",
    "eyeDropper": "",
    "followUs": "Seuraa meitä",
    "discordChat": "Discord-keskustelu",
    "zoomToFitViewport": "",
    "zoomToFitSelection": "",
    "zoomToFit": "",
    "installPWA": "",
    "autoResize": "",
    "imageCropping": "",
    "unCroppedDimension": "",
    "copyElementLink": "",
    "linkToElement": "",
    "wrapSelectionInFrame": "",
    "tab": "",
    "shapeSwitch": "",
    "preferences": "",
    "preferences_toolLock": "",
    "boxSelectionMode": "",
    "boxSelectionContain": "",
    "boxSelectionOverlap": "",
    "arrowBinding": "",
    "midpointSnapping": ""
  },
  "elementLink": {
    "title": "",
    "desc": "",
    "notFound": ""
  },
  "search": {
    "title": "",
    "noMatch": "",
    "singleResult": "",
    "multipleResults": "",
    "placeholder": "",
    "frames": "",
    "texts": ""
  },
  "buttons": {
    "clearReset": "Tyhjennä piirtoalue",
    "exportJSON": "Vie tiedostoon",
    "exportImage": "Vie kuva...",
    "export": "Tallenna nimellä...",
    "copyToClipboard": "Kopioi leikepöydälle",
    "copyLink": "",
    "save": "Tallenna nykyiseen tiedostoon",
    "saveAs": "Tallenna nimellä",
    "load": "Avaa",
    "getShareableLink": "Hae jaettava linkki",
    "close": "Sulje",
    "selectLanguage": "Valitse kieli",
    "scrollBackToContent": "Näytä sisältö",
    "zoomIn": "Lähennä",
    "zoomOut": "Loitonna",
    "resetZoom": "Nollaa suurennuksen taso",
    "menu": "Valikko",
    "done": "Valmis",
    "edit": "Muokkaa",
    "undo": "Kumoa",
    "redo": "Tee uudelleen",
    "createNewRoom": "Luo huone",
    "fullScreen": "Koko näyttö",
    "darkMode": "Tumma tila",
    "lightMode": "Vaalea tila",
    "systemMode": "Järjestelmätila",
    "zenMode": "Zen-tila",
    "objectsSnapMode": "",
    "exitZenMode": "Poistu zen-tilasta",
    "cancel": "Peruuta",
    "clear": "Pyyhi",
    "remove": "Poista",
    "embed": "",
    "submit": "Lähetä",
    "confirm": "Vahvista",
    "embeddableInteractionButton": ""
  },
  "alerts": {
    "clearReset": "Tämä tyhjentää koko piirtoalueen. Jatketaanko?",
    "couldNotCreateShareableLink": "Jaettavan linkin luominen epäonnistui.",
    "couldNotCreateShareableLinkTooBig": "Jaettavaa linkkiä ei voitu luoda: teos on liian suuri",
    "couldNotLoadInvalidFile": "Virheellistä tiedostoa ei voitu avata",
    "importBackendFailed": "Palvelimelta tuonti epäonnistui.",
    "cannotExportEmptyCanvas": "Tyhjää piirtoaluetta ei voi viedä.",
    "couldNotCopyToClipboard": "Leikepöydälle vieminen epäonnistui.",
    "decryptFailed": "Salauksen purkaminen epäonnistui.",
    "uploadedSecurly": "Lähetys on turvattu päästä-päähän-salauksella. Excalidrawin palvelin ja kolmannet osapuolet eivät voi lukea sisältöä.",
    "loadSceneOverridePrompt": "Ulkopuolisen piirroksen lataaminen korvaa nykyisen sisältösi. Jatketaanko?",
    "collabStopOverridePrompt": "Istunnon lopettaminen korvaa aiemman, paikallisesti tallennetun piirustuksen. Jatketaanko?\n\n(Jos haluat säilyttää paikallisesti tallennetun piirustuksen, sulje selaimen välilehti lopettamisen sijaan.)",
    "imageDoesNotContainScene": "Tämä kuva ei näytä sisältävän piirrostietoja. Oletko ottanut käyttöön piirroksen tallennuksen viennin aikana?",
    "cannotRestoreFromImage": "Teosta ei voitu palauttaa tästä kuvatiedostosta",
    "invalidSceneUrl": "Teosta ei voitu tuoda annetusta URL-osoitteesta. Tallenne on vioittunut, tai osoitteessa ei ole Excalidraw JSON-dataa.",
    "invalidEncryptionKey": "Salausavaimen on oltava 22 merkkiä pitkä. Live-yhteistyö ei ole käytössä.",
    "collabOfflineWarning": "Internet-yhteyttä ei ole saatavilla.\nMuutoksiasi ei tallenneta!",
    "localStorageQuotaExceeded": ""
  },
  "errors": {
    "unsupportedFileType": "Tiedostotyyppiä ei tueta.",
    "imageInsertError": "Kuvan lisääminen epäonnistui. Yritä myöhemmin uudelleen...",
    "fileTooBig": "Tiedosto on liian suuri. Suurin sallittu koko on {{maxSize}}.",
    "svgImageInsertError": "SVG- kuvaa ei voitu lisätä. Tiedoston SVG-sisältö näyttää virheelliseltä.",
    "failedToFetchImage": "",
    "cannotResolveCollabServer": "Yhteyden muodostaminen collab-palvelimeen epäonnistui. Virkistä sivu ja yritä uudelleen.",
    "collabSaveFailed": "Ei voitu tallentaan palvelimen tietokantaan. Jos ongelmia esiintyy, sinun kannatta tallentaa tallentaa tiedosto paikallisesti varmistaaksesi, että et menetä työtäsi.",
    "collabSaveFailed_sizeExceeded": "Ei voitu tallentaan palvelimen tietokantaan. Jos ongelmia esiintyy, sinun kannatta tallentaa tallentaa tiedosto paikallisesti varmistaaksesi, että et menetä työtäsi.",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "",
      "line2": "",
      "line3": "",
      "line4": ""
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "Ei voitu liittää.",
    "copyToSystemClipboardFailed": "Kopiointi leikepöydälle epäonnistui."
  },
  "toolBar": {
    "selection": "Valinta",
    "lasso": "",
    "image": "Lisää kuva",
    "rectangle": "Suorakulmio",
    "diamond": "Vinoneliö",
    "ellipse": "Soikio",
    "arrow": "Nuoli",
    "line": "Viiva",
    "freedraw": "Piirrä",
    "text": "Teksti",
    "lock": "Pidä valittu työkalu aktiivisena piirron jälkeen",
    "penMode": "Kynätila - estä kosketus",
    "link": "",
    "eraser": "Poistotyökalu",
    "frame": "",
    "embeddable": "Verkkoupote",
    "laser": "Laserosoitin",
    "autoshape": "",
    "bucketfill": "",
    "hand": "Käsi (panning-työkalu)",
    "extraTools": "Lisää työkaluja",
    "convertElementType": ""
  },
  "bucketfill": {
    "noRegion": "",
    "tooComplex": ""
  },
  "element": {
    "rectangle": "",
    "diamond": "",
    "ellipse": "",
    "arrow": "",
    "line": "",
    "freedraw": "",
    "text": "",
    "image": "",
    "group": "",
    "frame": "",
    "embeddable": "",
    "selection": "",
    "iframe": ""
  },
  "headings": {
    "canvasActions": "Piirtoalueen toiminnot",
    "selectedShapeActions": "Valitun muodon toiminnot",
    "shapes": "Muodot"
  },
  "hints": {
    "dismissSearch": "",
    "canvasPanning": "",
    "linearElement": "Klikkaa piirtääksesi useampi piste, raahaa piirtääksesi yksittäinen viiva",
    "arrowTool": "",
    "arrowBindModifiers": "",
    "freeDraw": "Paina ja raahaa, päästä irti kun olet valmis",
    "text": "Vinkki: voit myös lisätä tekstiä kaksoisnapsauttamalla mihin tahansa valintatyökalulla",
    "embeddable": "",
    "autoshape": "",
    "text_selected": "",
    "text_editing": "",
    "linearElementMulti": "",
    "lockAngle": "",
    "resize": "",
    "resizeImage": "",
    "rotate": "",
    "toggleArrowhead": "",
    "lineEditor_info": "",
    "lineEditor_line_info": "",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "bindTextToElement": "",
    "createFlowchart": "",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "Tämä ominaisuus voidaan todennäköisesti ottaa käyttöön asettamalla \"dom.events.asyncClipboard.clipboardItem\" kohta \"true\":ksi. Vaihtaaksesi selaimen kohdan Firefoxissa, käy \"about:config\" sivulla.",
    "disableSnapping": "",
    "enterCropEditor": "",
    "leaveCropEditor": ""
  },
  "canvasError": {
    "cannotShowPreview": "Esikatselua ei voitu näyttää",
    "canvasTooBig": "Piirtoalue saattaa olla liian suuri.",
    "canvasTooBigTip": "Vinkki: yritä siirtää kaukaisimpia elementtejä hieman lähemmäs toisiaan."
  },
  "errorSplash": {
    "headingMain": "Tapahtui virhe. Yritä <button>sivun lataamista uudelleen.</button>",
    "clearCanvasMessage": "Mikäli sivun lataaminen uudelleen ei auta, yritä <button>tyhjentää piirtoalue.</button>",
    "clearCanvasCaveat": " Tämä johtaa työn menetykseen ",
    "trackedToSentry": "Virhe tunnisteella {{eventId}} tallennettiin järjestelmäämme.",
    "openIssueMessage": "Olimme varovaisia emmekä sisällyttäneet tietoa piirroksestasi virheeseen. Mikäli piirroksesi ei ole yksityinen, harkitsethan kertovasi meille <button>virheenseurantajärjestelmässämme.</button> Sisällytä alla olevat tiedot kopioimalla ne GitHub-ongelmaan.",
    "sceneContent": "Piirroksen tiedot:"
  },
  "shareDialog": {
    "or": "Tai"
  },
  "roomDialog": {
    "desc_intro": "",
    "desc_privacy": "",
    "button_startSession": "Aloita istunto",
    "button_stopSession": "Lopeta istunto",
    "desc_inProgressIntro": "Jaettu istunto on nyt käynnissä.",
    "desc_shareLink": "Jaa tämä linkki kenelle tahansa, jonka kanssa haluat tehdä yhteistyötä:",
    "desc_exitSession": "Istunnon pysäyttäminen katkaisee yhteyden huoneeseen, mutta voit vielä jatkaa työskentelyä paikallisesti. Huomaa, että tämä ei vaikuta muihin käyttäjiin ja he voivat jatkaa oman versionsa parissa työskentelyä.",
    "shareTitle": "Liity Excalidraw live-yhteistyöistuntoon"
  },
  "errorDialog": {
    "title": "Virhe"
  },
  "progressDialog": {
    "title": "",
    "defaultMessage": ""
  },
  "exportDialog": {
    "disk_title": "Tallenna levylle",
    "disk_details": "Vie työn tiedot tiedostoon, josta sen voi tuoda myöhemmin.",
    "disk_button": "Tallenna tiedostoon",
    "link_title": "Jaettava linkki",
    "link_details": "Vie vain luku -linkkinä.",
    "link_button": "Vie linkkinä",
    "excalidrawplus_description": "Tallenna teos Excalidraw+ tilaan.",
    "excalidrawplus_button": "Vie",
    "excalidrawplus_exportError": "Ei voitu viedä Excalidraw+-palveluun tällä hetkellä..."
  },
  "helpDialog": {
    "blog": "Lue blogiamme",
    "click": "klikkaa",
    "deepSelect": "Syvävalinta",
    "deepBoxSelect": "Käytä syvävalintaa ja estä raahaus",
    "createFlowchart": "",
    "navigateFlowchart": "",
    "curvedArrow": "Kaareva nuoli",
    "curvedLine": "Kaareva viiva",
    "documentation": "Käyttöohjeet",
    "doubleClick": "kaksoisnapsautus",
    "drag": "vedä",
    "editor": "Muokkausohjelma",
    "editLineArrowPoints": "",
    "editText": "",
    "github": "Löysitkö ongelman? Kerro meille",
    "howto": "Seuraa oppaitamme",
    "or": "tai",
    "preventBinding": "Estä nuolten kiinnitys",
    "tools": "Työkalut",
    "shortcuts": "Pikanäppäimet",
    "textFinish": "Lopeta muokkaus (tekstieditori)",
    "textNewLine": "Lisää uusi rivi (tekstieditori)",
    "title": "Ohjeet",
    "view": "Näkymä",
    "zoomToFit": "Näytä kaikki elementit",
    "zoomToSelection": "Näytä valinta",
    "toggleElementLock": "Lukitse / poista lukitus valinta",
    "movePageUpDown": "Siirrä sivua ylös/alas",
    "movePageLeftRight": "Siirrä sivua vasemmalle/oikealle",
    "cropStart": "",
    "cropFinish": ""
  },
  "clearCanvasDialog": {
    "title": "Pyyhi piirtoalue"
  },
  "imageExportDialog": {
    "header": "",
    "label": {
      "withBackground": "",
      "onlySelected": "",
      "darkMode": "Tumma tila",
      "embedScene": "",
      "scale": "",
      "padding": ""
    },
    "tooltip": {
      "embedScene": ""
    },
    "title": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": "Kopioi PNG leikepöydälle"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "Kopioi leikepöydälle"
    }
  },
  "encrypted": {
    "tooltip": "Piirroksesi ovat päästä-päähän-salattuja, joten Excalidrawin palvelimet eivät koskaan näe niitä.",
    "link": "Blogiartikkeli päästä päähän -salauksesta Excalidraw:ssa"
  },
  "stats": {
    "angle": "Kulma",
    "shapes": "",
    "height": "Korkeus",
    "scene": "Teos",
    "selected": "Valitut",
    "storage": "Tallennustila",
    "fullTitle": "",
    "title": "",
    "generalStats": "",
    "elementProperties": "",
    "total": "Yhteensä",
    "version": "Versio",
    "versionCopy": "Klikkaa kopioidaksesi",
    "versionNotAvailable": "Versio ei saatavilla",
    "width": "Leveys"
  },
  "toast": {
    "copyStyles": "Tyylit kopioitiin.",
    "copyToClipboard": "Kopioitiin leikepöydälle.",
    "copyToClipboardAsPng": "Kopioitiin {{exportSelection}} leikepöydälle PNG:nä\n({{exportColorScheme}})",
    "copyToClipboardAsSvg": "",
    "fileSaved": "Tiedosto tallennettu.",
    "fileSavedToFilename": "Tallennettiin kohteeseen {filename}",
    "canvas": "piirtoalue",
    "selection": "valinta",
    "pasteAsSingleElement": "Käytä {{shortcut}} liittääksesi yhtenä elementtinä,\ntai liittääksesi olemassa olevaan tekstieditoriin",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": "",
    "elementLinkCopied": ""
  },
  "colors": {
    "transparent": "Läpinäkyvä",
    "black": "Musta",
    "white": "Valkoinen",
    "red": "Punainen",
    "pink": "Pinkki",
    "grape": "Rypäle",
    "violet": "Violetti",
    "gray": "Harmaa",
    "blue": "Sininen",
    "cyan": "Syaani",
    "teal": "Sinivihreä",
    "green": "Vihreä",
    "yellow": "Keltainen",
    "orange": "Oranssi",
    "bronze": "Pronssi"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_line2": "",
      "center_heading_line3": "",
      "center_heading_plus": "Haluatko sen sijaan mennä Excalidraw+:aan?",
      "menuHint": "Vie, asetukset, kielet, ..."
    },
    "defaults": {
      "menuHint": "Vie, asetukset ja lisää...",
      "center_heading": "Kaaviot. Tehty. Yksinkertaiseksi.",
      "toolbarHint": "Valitse työkalu ja aloita piirtäminen!",
      "helpHint": "Pikanäppäimet & ohje"
    }
  },
  "colorPicker": {
    "color": "",
    "mostUsedCustomColors": "Eniten käytetyt omat värit",
    "colors": "Värit",
    "shades": "Varjot",
    "hexCode": "Hex koodi",
    "noShades": "",
    "invalidColor": "",
    "invalidHexLength": "",
    "topPicksTip": "",
    "resetTopPicks": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "Vie kuva",
        "button": "Vie kuva",
        "description": ""
      },
      "saveToDisk": {
        "title": "Tallenna levylle",
        "button": "Tallenna levylle",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "Excalidraw+",
        "button": "Vie Excalidraw+:aan",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "Lataa tiedostosta",
        "button": "Lataa tiedostosta",
        "description": ""
      },
      "shareableLink": {
        "title": "",
        "button": "",
        "description": ""
      }
    }
  },
  "quickSearch": {
    "placeholder": ""
  },
  "fontList": {
    "badge": {
      "old": ""
    },
    "sceneFonts": "",
    "availableFonts": "",
    "empty": ""
  },
  "userList": {
    "empty": "",
    "hint": {
      "text": "",
      "followStatus": "",
      "inCall": "",
      "micMuted": "",
      "isSpeaking": ""
    }
  },
  "keys": {
    "ctrl": "",
    "option": "",
    "cmd": "",
    "alt": "",
    "escape": "",
    "enter": "",
    "shift": "",
    "spacebar": "",
    "delete": "",
    "mmb": ""
  }
}
